<script setup>
import { computed } from 'vue'
import { usePermissions } from '@/composables/usePermissions.js'
import { BULK_EDIT_RESOURCES } from '@/config/bulkEditResources.js'
import BasePageHeader from '@/components/base/BasePageHeader.vue'
import MdiTableEdit from '~icons/mdi/table-edit'

const permissions = usePermissions()
const available = computed(() => Object.entries(BULK_EDIT_RESOURCES).filter(([, resource]) =>
  permissions[resource.permission]?.value === true
))
</script>

<template>
  <div class="page-view">
    <BasePageHeader :title="$t('bulkEdit.title')" @back="$router.back()" />
    <p class="px-4 pt-3 text-sm text-[var(--color-muted)]">{{ $t('bulkEdit.intro') }}</p>
    <p v-if="!available.length" class="state-empty">{{ $t('bulkEdit.noAccess') }}</p>
    <div class="list-stack">
      <router-link
        v-for="[key, resource] in available"
        :key="key"
        :to="`/bulk-edit/${key}`"
        class="data-card"
      >
        <MdiTableEdit class="w-5 h-5 text-[var(--color-accent)]" />
        <span class="data-card__main data-card__name">{{ $t(`bulkEdit.resources.${key}`) }}</span>
      </router-link>
    </div>
  </div>
</template>
